import React from 'react';
import DashSidebar from './DashSidebar';
import UpdateJewelry from './UpdateJewelry';
import { Link, useLocation } from 'react-router-dom';
import UploadProduct from './UploadProduct';
import AddJewelry from './AddJewelry';
import ExportJewelry from './ExportJewelry';

const DashJewelry = () => {
    const location = useLocation();
    // Determine the active class based on the current route
    const getActiveClass = (route) => {
        return location.pathname === route ? "active" : "";
    };
    return (
        <>
            <section className="mt-3">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2">
                            <DashSidebar activeClass={getActiveClass("/dashboard")} />
                        </div>
                        <div className="col-sm-10 light-border p-4">
                            <div className="control-btn-nav pb-3 row">
                                <div className="col-sm-9">
                                    <h3><b>Maitri Jewellery </b></h3>
                                </div>
                                <div className="col-sm-3 d-flex align-items-center">
                                    <Link className="ms-4 text-dark" data-bs-toggle="modal" data-bs-target="#exportModal">
                                        Export
                                    </Link>
                                    <ExportJewelry />

                                    <Link className="ms-4 text-dark" data-bs-toggle="modal" data-bs-target="#importModal">
                                        Import
                                    </Link>
                                    <UploadProduct />

                                    <Link className="ms-4 btn btn__primary" data-bs-toggle="modal" data-bs-target="#addproductModal">
                                        Add Jewellery
                                    </Link>
                                    <AddJewelry /> 
                                </div>
                            </div>


                            <div className="content">
                                <UpdateJewelry />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DashJewelry